import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, ConfirmationService, MessageService, } from 'primeng/api';
import { ReviewsService } from 'src/app/services/reviews.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-academies-reviews',
  templateUrl: './academies-reviews.component.html',
  styleUrls: ['./academies-reviews.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class AcademiesReviewsComponent implements OnInit {
  val2: number = 4;
  totalRating: number = 0;
  oneStar: number;
  twoStar: number;
  threeStar: number;
  fourStar: number;
  fiveStar: number;
  userId: any;
  isLogin: boolean;
  isAcademy: boolean;
  loggedInAcademy: any = [];
  id: any;
  totalRecords;
  private lazyLoadEvent: LazyLoadEvent;
  reviewsList: any;
  pageNumber: number = 1;
  reviewsListArray: any = [];
  loading;
  tempReviewsList: any = [];
  errorMessage;
  constructor(
    private confirmationService: ConfirmationService, private messageService: MessageService, private renderer: Renderer2, private activatedRoute: ActivatedRoute, private tokenStorageService: TokenStorageService, private reviewsService: ReviewsService
  ) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'reviews-page');
    this.loggedInAcademy = this.tokenStorageService.getUser();
    if (this.loggedInAcademy?.userdata != undefined) {
      this.userId = this.loggedInAcademy.userdata.id;
      this.id = this.loggedInAcademy.userdata.academyId;
      this.isLogin = true;
      if (this.loggedInAcademy?.userdata.rolename == "academy") {
        this.isAcademy = true;
      } else {
        this.isAcademy = false;
      }
    } else {
      this.isLogin = false;
    }
    this.getReviews(this.lazyLoadEvent);
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'reviews-page');
  }
  getReviews(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let params = "";
    let rows = 10;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        this.pageNumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        this.pageNumber = (event.first / event.rows) + 1;
      } else {
        this.pageNumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + this.pageNumber + params;
    query += "&filterByAcademyId=" + this.id;
    this.reviewsListArray = [];
    this.reviewsListArray = Object.assign([], this.reviewsList);
    this.reviewsService.getReviewsList(query).subscribe(
      async data => {
        this.loading = false;
        this.tempReviewsList = data.data.items;
        this.reviewsList = [...this.reviewsListArray, ...this.tempReviewsList];
        this.totalRecords = data.data.totalCount;
        let reviewCountGroup = data.reviewCountGroup;
        let oneStarCount = 0;
        let twoStarCount = 0;
        let threeStarCount = 0;
        let fourStarCount = 0;
        let fiveStarCount = 0;
        let oneStar = 0;
        let twoStar = 0;
        let threeStar = 0;
        let fourStar = 0;
        let fiveStar = 0;
        if (reviewCountGroup.length > 0) {
          reviewCountGroup.forEach(element => {
            if (element._id === environment.rating[0]) {
              oneStarCount = element.count;
              oneStar = element.sum;
            }
            if (element._id === environment.rating[1]) {
              twoStarCount = element.count;
              twoStar = element.sum;
            }
            if (element._id === environment.rating[2]) {
              threeStarCount = element.count;
              threeStar = element.sum;
            }
            if (element._id === environment.rating[3]) {
              fourStarCount = element.count;
              fourStar = element.sum;
            }
            if (element._id === environment.rating[4]) {
              fiveStarCount = element.count;
              fiveStar = element.sum;
            }
          });
        }
        let totalRating = Number(oneStar) + Number(twoStar) + Number(threeStar) + Number(fourStar) + Number(fiveStar);
        if (Number(totalRating) > 0) {
          this.totalRating = Number(totalRating) / Number(this.totalRecords);
          this.oneStar = (Number(oneStarCount) / this.totalRecords) * Number(100);
          this.twoStar = (Number(twoStarCount) / this.totalRecords) * Number(100);
          this.threeStar = (Number(threeStarCount) / this.totalRecords) * Number(100);
          this.fourStar = (Number(fourStarCount) / this.totalRecords) * Number(100);
          this.fiveStar = (Number(fiveStarCount) / this.totalRecords) * Number(100);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    )
  }
  onClickDelete(review) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this review?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (review.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updateData = '{"disable":' + disableStatus + '}';
        this.reviewsService.updateReviews(review.id, updateData).subscribe(
          data => {
            this.messageService.add({ key: 'toastMsg', severity: 'success', summary: 'Successful', detail: 'Review Deleted', life: 3000 });
            this.pageNumber = 1;
            this.reviewsList = [];
            this.getReviews(this.lazyLoadEvent);
          },
          err => {
            this.messageService.add({ key: 'toastMsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        this.pageNumber = 1;
        this.reviewsList = [];
        this.getReviews(this.lazyLoadEvent);
      }
    })
  }
  onClickLoadMore() {
    this.pageNumber++;
    this.getReviews(this.lazyLoadEvent);
  }

}
